import { render } from "./PurchaseSuccessView.vue?vue&type=template&id=72689c90&scoped=true"
import script from "./PurchaseSuccessView.vue?vue&type=script&lang=js"
export * from "./PurchaseSuccessView.vue?vue&type=script&lang=js"

import "./PurchaseSuccessView.vue?vue&type=style&index=0&id=72689c90&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72689c90"]])

export default __exports__